document.addEventListener('DOMContentLoaded', () => {
    async function fetchShippingRates() {
        try {
            // Configurar el cuerpo de la solicitud
            const payload = {
                param1: "Aqui va el 111111",
                param2: "Aqui va el 222222",
            };

            const response = await fetch('https://odoo.ibertix.es/api/shipping', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'A1b2C3d4E5f6G7h8!@i9J0k1L2m3N4o5P6#Q7r8S9t0U1v2W3x4Y5z6$Z7',
            },
            body: JSON.stringify(payload),
        });

          
            if (!response.ok) {
                throw new Error(`Error en la solicitud: ${response.statusText}`);
            }

            const shippingData = await response.json();
            console.log('Datos de envío:', shippingData);

            // Actualiza el DOM con la información del envío
            const shippingRateElement = document.getElementById('shipping-rate');
            shippingRateElement.innerText = `Costo de envío: $${(shippingData.total_price / 100).toFixed(2)} ${shippingData.currency}`;
        } catch (error) {
            console.error('Error al calcular el envío:', error);
        }
    }

    // Llama a la función para calcular el envío
    fetchShippingRates();
});
